import { render, staticRenderFns } from "./ChatLog.vue?vue&type=template&id=63306c90&scoped=true&"
import script from "./ChatLog.vue?vue&type=script&lang=js&"
export * from "./ChatLog.vue?vue&type=script&lang=js&"
import style0 from "./ChatLog.vue?vue&type=style&index=0&id=63306c90&prod&lang=scss&"
import style1 from "./ChatLog.vue?vue&type=style&index=1&id=63306c90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63306c90",
  null
  
)

export default component.exports